module.exports = __webpack_public_path__ + "static/media/pkw.3c5c945f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/gift/pkw.svg
// module id = 916
// module chunks = 0